// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_ARTICLE_EXPERIENCES = ["%(count)s sk\u00fasenos\u0165", "%(count)s sk\u00fasenosti", "%(count)s sk\u00fasenost\u00ed"];
export const WIKI_REVIEW_CATEGORY__counter_OF_PRODUCT_REVIEWS = ["%(counter)s produkt", "%(counter)s produkty", "%(counter)s produktov"];
